<input type="text" id="search-box" class="form-control" autocomplete="off" placeholder="{{ 'app.search' | translate }}"
  [(ngModel)]="term">

<div class="search-result typology-search">
  @switch (status) {
  @case ('ok') {
  @for (calendar of calendars | stringFilter:term; track $index) {
  <div (click)="onSelectCalendar(calendar)">
    {{ calendar.name }}
  </div>
  }
  }
  @case ('busy') {
  <div class="spinneram" style="padding-top:0">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
    {{'app.loading-message'| translate}}
  </div>
  }
  }

</div>